class YearQuarter {
	constructor(quarterNum, fromDate) {
		this.num = quarterNum;

		const quarterNumInAYear = quarterNum % 4 === 0 ? 4 : quarterNum % 4;
		const numOfYears = Math.ceil(quarterNum / 4) - 1;
		const startingMonth = (quarterNumInAYear - 1) * 3 + 1;
		const endingMonth = quarterNumInAYear * 3;

		this.startDate = new Date(fromDate.getFullYear() + numOfYears, startingMonth - 1, 1);
		this.endDate = new Date(fromDate.getFullYear() + numOfYears, endingMonth, 0);
	}
}

export default function YearQuarterBuilder() {
	return {
		withQuarterNum: function (quarterNum) {
			this.quarterNum = quarterNum;
			return this;
		},
		withFromDate: function (fromDate) {
			this.fromDate = fromDate;
			return this;
		},
		build: function () {
			return new YearQuarter(this.quarterNum, this.fromDate);
		}
	};
}
